/** Release Jupiter swap plugin + DexScreener iframes before route changes (mint/community pages). */
export function teardownHeavyTokenWidgets() {
  if (typeof window === "undefined") return;
  try {
    const J = window.Jupiter;
    if (J && typeof J.close === "function") J.close();
  } catch {
    /* noop */
  }
  try {
    document.querySelectorAll('iframe[src*="dexscreener.com"]').forEach((node) => {
      if (node instanceof HTMLIFrameElement) node.src = "about:blank";
    });
  } catch {
    /* noop */
  }
}
